module.exports = __webpack_public_path__ + "static/steam_mephit-a23c7c1521c7a15d309636a6f5b6a357.jpeg";